import { Component } from '@angular/core';

import { ScrollReveal, ScrollRevealItem } from '@shared/directives';

@Component({
  selector: 'app-our-origin',
  imports: [ScrollReveal, ScrollRevealItem],
  templateUrl: './our-origin.html',
  styleUrl: './our-origin.scss',
})
export class OurOrigin {
  protected readonly storyParagraphs: readonly string[] = [
    'My work with Google Brain Lab (which later merged with DeepMind) began in early 2018, after years as a world-building artist. Those two years inside Google taught me how machine learning worked at the genesis level, its strengths and its shortcomings for creative storytellers like myself.',
    "I carried that fascination into motion pictures. I created one of the world's first AI VFX for a feature film, Descending the Mountain, in 2020, and one of the first generative AI commercials, Connections for Beko, in 2021.",
    "In December 2022, weeks after the launch of ChatGPT, my late partner Gary Koepke and I founded Cuebric, the first generative AI platform purpose-built for virtual production stages. Building Cuebric through 2023 and 2024 placed us at the heart of the studio system, working with the world's most extraordinary production technologists and learning their workflows, what fascinated and frustrated them. Cuebric was built for what the technology made possible at the time. It turned 2D pictures into 2.5D parallax and exported generative 2.75D meshes. We couldn't generate full 3D, the technology wasn't there yet.",
    "In 2026, generative 3D has finally matured enough to let me execute the dream I'd been carrying: to build the control layer for generative media. EVRN is built on everything Cuebric, Google, our partners, my 11-year background as an artist, the studio system, and most importantly our team have taught me.",
    "We truly hope you'll have as much joy and satisfaction using EVRN as we felt while building it.",
  ];

  protected readonly signatureLines: readonly string[] = [
    'With great respect for you and your craft,',
    'Pinar Seyhan Demirdağ',
  ];
}
